import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'productInspectionSettingDetailsPut',
    method: 'PUT',
  });
  useEffect(() => {
    if (param) {
      exec({ url: `/api/inspection_product_configs/details/${param.id}`, data: param })
      // exec({
      //   url: '/api/inspection_product_configs/details?id=' + param.id + '&inspect_type='
      //     + param.inspect_type + '&is_enabled=' + param.is_enabled,
      //   data: param
      // })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return [isRequestSuccessed, exec];
});